<template>
  <div :class="['modal', 'animated', show ? 'is-active' : '']">
    <div class="modal-background"></div>
    <div class="account-wrapper">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ title }}</p>
          <button class="delete" @click="afterLeave()"></button>
        </header>
        <section class="modal-card-body">
          <div class="content">
            <template v-for="notification in context.$store.state.config.notifications.slice().reverse()">
              <div class="box">
                <article class="media">
                  <div class="media-content">
                    <div class="content">
                      <p>
                        <strong>{{ notification.user_name }}</strong>
                        <small>{{ notification.created_at | moment('from') }}</small>
                        <br>
                      <p v-html="notification.notification"></p>
                      <nav class="level">
                        <div class="level-left">
                          <a class="level-item" @click="viewOccurrence(notification.id, notification.occurrence_id)">
                            <span class="icon is-small"><i class="fa fa-reply"></i></span>
                          </a>
                        </div>
                      </nav>
                    </div>
                  </div>
                </article>
              </div>
            </template>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      card: Boolean,
      visible: Boolean,
      context: Object
    },
    data () {
      return {
        show: true,
        title: 'Notifications'
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    },
    destroyed () {
      this.$el.remove()
    },
    methods: {
      afterLeave () {
        this.$destroy()
      },
      url (id) {
        window.open('#/occurrences/occurrence/' + id)
      },
      active () {
        this.show = true
      },
      deactive () {
        this.show = false
      },
      close () {
        this.deactive()
      },
      open () {
        this.active()
      },
      viewOccurrence (id, occurrence) {
        window.open('#/occurrences/occurrence/' + occurrence)
        this.context.$http.post(this.context.$store.state.config.apiURL + '/notifications/' + id + '/read').then((response) => {
          this.context.$store.dispatch('READ_NOTIFICATION', id)
          // this.context.$router.push({name: 'Occurrence', params: {id: occurrence}})
          // this.afterLeave()
        }, (response) => {
        })
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .modal-card-foot {
    align-items: center;
    background-color: whitesmoke;
    display: block;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 20px;
    position: relative;
  }
  .content a:not(.button) {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// Notifications.vue?33c26a22